
import PropTypes from 'prop-types'
import React from 'react'
import Space from 'ui/Space'
import Link from 'ui/Link'
import './related-links.css'

const RelatedLinks = props => {
  const links = []

  // not all partners have "media" atm
  if (!props.links || !props.links.length) return <noscript />

  for (let i = 0; i < props.links.length; i++) {
    const link = props.links[i]
    if (link.type !== 'link') continue
    links.push(
      <li key={`info_sheet_related_links_link_${i}`}>
        <Link href={link.href} rel={link.rel} target={link.target}>{link.description}</Link>
      </li>
    )
  }

  return (
    <div className='InfoSheetRelatedLinks'>
      <span className='InfoSheetRelatedLinks-title'>related links</span>
      <Space value='5' />
      <ul>{links}</ul>
    </div>
  )
}

RelatedLinks.propTypes = {
  links: PropTypes.array.isRequired
}

RelatedLinks.displayName = 'InfoSheet RelatedLinks'

export default RelatedLinks



// WEBPACK FOOTER //
// ./ui/InfoSheet/components/related-links.js